/**
 * El arranque por defecto de las pantallas que cargan listados largos.
 *
 * Por qué existe: las tres páginas con rango de fechas —producción diaria,
 * pedidos de venta y pedidos de compra— arrancaban con el rango VACÍO, que
 * significa «desde el principio de los tiempos». Medido en producción el
 * 2026-10-14: `/v1/pedidos-ventas?desde=&hasta=` traía 58.508 filas en 11,5 s y
 * `/v1/produccion-diaria?desde=&hasta=` 41.149 en 7,9 s, en cada visita y en
 * cada recarga. Ninguna llegó a caerse, pero son la misma clase de petición que
 * sí tumbó un contenedor ese día desde el export de consumos, y crecen solas.
 *
 * Arrancar en el 1 de enero del año en curso es el corte que casi nadie nota:
 * el trabajo del día a día cae dentro, y quien necesite histórico sólo tiene
 * que mover la fecha.
 *
 * NO es un tope: es un valor INICIAL. El usuario puede vaciarlo y ver todo —en
 * esta aplicación mirar el histórico completo es legítimo—. Lo que ya no pasa
 * es que se traiga todo sin que nadie lo haya pedido.
 */

/** `YYYY-01-01` del año en curso, en el formato ISO corto que usan los filtros. */
export function inicioAnoActual(hoy: Date = new Date()): string {
  return `${hoy.getFullYear()}-01-01`
}

/**
 * Lo que vale el filtro al abrir la página: lo que diga la URL si lo dice, y si
 * no, el 1 de enero.
 *
 * El matiz está en distinguir «la URL no trae el parámetro» (primera visita →
 * se aplica el defecto) de «la URL lo trae vacío» (el usuario lo borró a
 * propósito → se respeta). `searchParams.get` devuelve `null` en el primer caso
 * y `''` en el segundo, y por eso aquí NO vale un `||`: convertiría el vacío
 * deliberado en el defecto y el usuario no podría quitarse el filtro de encima.
 */
export function desdeInicial(param: string | null, hoy: Date = new Date()): string {
  return param ?? inicioAnoActual(hoy)
}
